var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view',{key:_vm.$route.fullPath},[_c('Home')],1),_c('Footer'),_c('div',{staticClass:"bg-wrapper",attrs:{"id":"wrapper"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }